import { Box, styled } from '@arpeggi/ui'

export const MAIN_COLUMN_WIDTH = 260

const Root = styled(Box, {
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  padding: '12px 16px',
  gap: '4px',
  variants: {
    layout: {
      fluid: {
        flex: 1
      },
      noshrink: {
        flexShrink: 0
      },
      fluid2: {
        flex: 2
      }
    },
    hideOnMobile: {
      true: {
        display: 'none',
        '@tablet': { display: 'flex' }
      }
    }
  }
})

const Text = styled('div', {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  text: '14',
  color: '$blackA500'
})

export const Column = { Root, Text }
